import { PBIReport } from '@esg/esg-global-types';
import { createContext } from 'react';

export type DashboardStatus = 'idle' | 'prefetching' | 'bootstrapping' | 'preloaded' | 'error';

export interface CommentsPanelParameters {
  reportId: string;
  clientId: string;
  visualId: string;
}

interface DashboardContextProps {
  validPbiReports: Array<PBIReport>;
  invalidPbiReports: Array<PBIReport | null>;
  dashboardStatus: DashboardStatus;
  priorityReports: Array<PBIReport>;
  setPriorityReports: (reports: Array<PBIReport>) => void;
  lastTokenRefresh: number;
  commentsPanelOpen: boolean;
  commentsPanelParameters: CommentsPanelParameters | null;
  openCommentsPanel: (parameters: CommentsPanelParameters) => void;
  closeCommentsPanel: () => void;
}

export const DashboardContext = createContext<DashboardContextProps>({
  validPbiReports: [],
  invalidPbiReports: [],
  dashboardStatus: 'idle',
  priorityReports: [],
  setPriorityReports: () => null,
  lastTokenRefresh: 0,
  commentsPanelOpen: false,
  commentsPanelParameters: null,
  openCommentsPanel: () => null,
  closeCommentsPanel: () => null
});
